// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7854e280","703":"986d55f8"}[chunkId] + ".chunk.js";
};